import React from 'react';
import propTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import ComponentUsage from 'app/ComponentUsage/container';
import { noop } from 'lib/noop';
import { ClearButton, PrimaryButton } from 'ui/Components';

/**
 * This component can be used to show a modal with Edit Original and Edit Copy buttons.
 * @returns {React.Component} a react component with with Edit Original and Edit Copy buttons.
 */
const EditComponentModal = ({
  isOpen,
  onCancelClick,
  onEditOriginalClick,
  onEditCopyClick,
  unboundVisitPage,
  unboundVisitComponent
}) => (
  <Modal isOpen={isOpen} data-test-id="editComponentModal-componentUsage-modal">
    <ModalHeader toggle={onCancelClick}>Edit Component</ModalHeader>
    <ModalBody>
      Changes to this component will affect the following page(s) and/or container(s):
      <ComponentUsage
        unboundVisitComponent={unboundVisitComponent}
        unboundVisitPage={unboundVisitPage}
      />
      Do you want to detach and edit a copy or edit the original component?
    </ModalBody>
    <ModalFooter>
      <ClearButton
        color="secondary"
        onClick={onEditOriginalClick}
        data-test-id="editComponentModal-componentUsage-editOriginal"
      >
        Edit Original
      </ClearButton>
      {onEditCopyClick && (
        <PrimaryButton
          onClick={onEditCopyClick}
          data-test-id="editComponentModal-componentUsage-createCopy"
        >
          Edit Copy
        </PrimaryButton>
      )}
    </ModalFooter>
  </Modal>
);

EditComponentModal.propTypes = {
  isOpen: propTypes.bool,
  onCancelClick: propTypes.func,
  onEditOriginalClick: propTypes.func,
  onEditCopyClick: propTypes.func,
  unboundVisitComponent: propTypes.func.isRequired,
  unboundVisitPage: propTypes.func.isRequired
};

EditComponentModal.defaultProps = {
  isOpen: false,
  onCancelClick: noop,
  onEditOriginalClick: noop,
  onEditCopyClick: undefined
};

export default EditComponentModal;
